import { CheckIcon, CloseIcon, DashIcon } from "@codat/orchard-ui";
import * as React from "react";

import styles from "../CompaniesTable/CompaniesTable.module.css";

interface Props {
  value: PropValue;
}

interface PropValue {
  current: string;
  integration: string;
  isLatest(integration: string, version: string): boolean;
}

function GetIcon(value: PropValue) {
  if (value.integration === "qbwc") {
    return <DashIcon />;
  } else if (value.isLatest(value.integration, value.current)) {
    return <CheckIcon fillColor="green" />;
  } else {
    return <CloseIcon fillColor="red" />;
  }
}

const LatestVersionChip: React.FC<Pick<Props, "value">> = ({ value }) => {
  return <div className={styles.latestVersionContainer}>{GetIcon(value)}</div>;
};

export default LatestVersionChip;
